import apiClient, { extractData } from '../api-client';

export const auditLogApi = {
  list(params) {
    return apiClient.get('/audit-logs', { params }).then(extractData);
  },
};
